export const iconFontAwesomeCommunicationFaceFrown = (
	<i className="fa-solid fa-face-frown"></i>
);
